angular.module('NumbersEditor')
    .factory('NewAdhocGameFactory', [
        '$http', function ($http) {

            var urlBase = '/api/Game';
            var newAdhocGameFactory = {};

            newAdhocGameFactory.getNewAdhocGame = function () {
                return $http.get(urlBase + "/NewAdhocGame");
            };
            return newAdhocGameFactory;
        }
    ]);